import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { DataGrid, GridColumns, GridRowsProp } from "@mui/x-data-grid";

import TextField from "@mui/material/TextField";

/*  T O O L B A R  */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";

/*  T O O L T I P  */
import Tooltip from "@mui/material/Tooltip";

/* G R I D  */
import Grid from "@mui/material/Grid";

/* C U S T O M I Z A D O  S */
import ParametroTopo from "./topo";
import { hasInCache } from "../../helper/cacheHelper";
import PageHelper from "../../helper/pageHelper";
import ParceiroAgregado from "../../components/classes/ParceiroAgregado";

import Button from "@mui/material/Button";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { UserContext } from "../../App";
import ParceiroAgregadoDataset from "../../components/data/parceiroAgregadoDataset";
import ParametroPortal from "../../components/classes/ParametroPortal";
import { useTranslation } from "react-i18next";

interface Data {
  id: number;
  cliforSAPAgregado: number;
}

export const ParceiroAgregadoDetalhe = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);

  const [parceirosAgregados, SetParceirosAgregados] = useState<
    ParceiroAgregado[]
  >([]);
  const [registro, SetRegistro] = useState<ParceiroAgregado>(
    () => new ParceiroAgregado()
  );
  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<ParceiroAgregado>(
    () => new ParceiroAgregado()
  );
  const data: ParceiroAgregadoDataset = new ParceiroAgregadoDataset();

  const [codigoFornecedorSap, setCodigoFornecedorSap] = useState(0);

  const [habilita, setHabilita] = useState(true);
  const [defaultValue, SetDefaultValue] = useState("");

  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(true);

  const [loading, setloading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [columns, setColumns] = useState<GridColumns>([]);
  const [rows, setRows] = useState<Data[]>([]);

  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);

  function createData(id: number, cliforSAPAgregado: number): Data {
    return {
      id,
      cliforSAPAgregado,
    };
  }

  useEffect(() => {
    setloading(true);

    var _codigoFornecedorSap: number = Number(
      localStorage.getItem("CodigoFornecedorSAPSelecionado")
    );
    if (_codigoFornecedorSap === 0) {
      Mensagem(
        t('global.message.warning'),
        t('global.message.selectPartner')
      );
      setTimeout(() => {
        sai();
      }, 2000);
    }
    setCodigoFornecedorSap(_codigoFornecedorSap);

    data.ListarAtivos(_codigoFornecedorSap).then((result) => {
      SetParceirosAgregados(result);
      setloading(false);
      if (result.length > 0) {
        MontaColunas();
        preencherGrid(result);
      }
    });
  }, []);

  function sai() {
    var logoutUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port === "" ? "" : ":" + window.location.port) +
      "/";
    location.href = logoutUrl;
  }

  useEffect(() => {
    if (excluiItem === true) {
      data.Apagar(itemToExcluir).then((result) => {
        if (result) {
          //MensagemWithCustomUI(result, "Não foi possível excluir o parâmetro.");
          //   Mensagem("Aviso !",  "Não foi possível excluir o parâmetro.");
          //  }else{
          localStorage.removeItem("PropriedadeIdSel");
          setMensagem(t('global.message.parameterDeleted'));
          setSeverity(0);
          PageHelper.refreshPage();
        }
      });
    }
    setExcluiItem(false);
    setItemExcluir(new ParceiroAgregado());
    setRefresh(!refresh);
  }, [excluiItem]);

  const handleClickNew = () => {
    setHabilita(true);
    SetRegistro(new ParceiroAgregado());
  };

  const handlerPropriedadeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, cliforSAPAgregado: Number(e.target.value) };
    });
  };

  const handleIncluirClick = () => {
    var parametroToAdd = new ParceiroAgregado();
    parametroToAdd.codigoFornecedorSAP = codigoFornecedorSap;
    parametroToAdd.cliforSAPAgregado = registro.cliforSAPAgregado;
    data.Adicionar(parametroToAdd);
    Mensagem( 
      t('global.message.warning'),
      t('global.message.partnerAdded')
    );
    localStorage.removeItem("ParametroSel");
    handleClickNew();
    setHabilita(false);
  };

  const handleAtualizaClick = () => {
    var parametroToUpd = new ParceiroAgregado();
    parametroToUpd.cliforSAPAgregado = registro.cliforSAPAgregado;
    parametroToUpd.codigoFornecedorSAP = registro.codigoFornecedorSAP;
    parametroToUpd.id = registro.id;

    data.Atualizar(parametroToUpd).then((result) => {
      console.log(result);
      if (result) {
        //MensagemWithCustomUI(result, "Não foi possível atualizar o parâmetro.");
        // Mensagem("Aviso !", "Não foi possível atualizar o parâmetro.");
        // }else{
        localStorage.removeItem("ParametroSel");
        Mensagem(
          t('global.message.warning'),
          t('global.message.partnerUpdated')
        );
        handleClickNew();
        setHabilita(false);
      }
    });
  };

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const MensagemWithCustomUI = (result: string, title: string) => {
    confirmAlert({
      customUI: () => (
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body">
            <h1>{title}</h1>
            {result.split("\n").map((item: string) => {
              console.log("sss");
              return <p>{item}</p>;
            })}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={() => {
                  setOpen(false);
                  PageHelper.refreshPage();
                }}
              >
                {t('global.button.ok')}
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      setItemExcluir(
        parceirosAgregados.filter((f) => f.id === cellValues.row.id)[0]
      );
      handleClickOpen();
    }
  };

  /* const handleSelectionChange = (id: any) => {
    if (id !== null && id !== undefined && id > 0) {
      localStorage.setItem("ParceiroAgregadoIdSel", id);
      parceirosAgregados.map(function (item: ParceiroAgregado) {
        if (item.id === Number(id)) {           
          SetDefaultValue(String(item.cliforSAPAgregado));
          SetRegistro(item);          
          setHabilita(true);          
        }
      })
    }
    else {
      localStorage.removeItem("ParceiroAgregadoIdSel");
      setHabilita(false);
    }
  }
*/
  function preencherGrid(_itens: ParceiroAgregado[]) {
    setRows(
      _itens.map((_Item: ParceiroAgregado) => {
        return createData(Number(_Item.id), Number(_Item.cliforSAPAgregado));
      })
    );
    setloading(false);
  }

  function TransitionAlerts(_severity: number, _mensagem: string) {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  }

  function MontaColunas() {
    let columns1: GridColumns = [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "cliforSAPAgregado",
        headerName: t('global.table.partnerAggregated'),
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "deleteico",
        headerName: "",
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        align: "center",
        renderCell: () => {
          return (
            <IconButton disabled={user.isSuporte}>
              {" "}
              <EraseIcon />
            </IconButton>
          );
        },
      },
    ];
    setColumns(columns1);
  }

  return (
    <div className="container">
      <ParametroTopo />
      <div className="containerToolbar">
        <Tooltip title={t('global.tooltip.newParameter')}>
          <span>
            <IconButton onClick={handleClickNew} disabled={user.isSuporte}>
              <NewIcon />
            </IconButton>
          </span>
        </Tooltip>
        {registro.cliforSAPAgregado.valueOf() > 0 ? (
          <Tooltip title={t('global.tooltip.updateParameter')}>
            <span>
              <IconButton
                onClick={
                  registro.id === 0 ? handleIncluirClick : handleAtualizaClick
                }
                disabled={user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
      <div className="insiderContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id={"Clifor"}
              name={"Clifor"}
              label="Clifor"
              fullWidth
              variant="outlined"
              value={registro.cliforSAPAgregado}
              onChange={handlerPropriedadeChange}
              sx={{ minWidth: "200px" }}
              disabled={!habilita}
            />
          </Grid>
        </Grid>
        <br />
      </div>
      <div className="insiderContainer">
        <>
          <div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {t('global.dialog.deletePartnerAggregated')}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t('global.dialog.deletePartnerAggregatedSubTitle')}
                  <br />
                  <br />
                  {t('global.dialog.providerCode')}
                  <strong>
                    {itemToExcluir.codigoFornecedorSAP}
                    <strong />
                  </strong>
                  <br />
                  CliforSAP : <strong>{itemToExcluir.cliforSAPAgregado}</strong>
                  <br />
                  {t('global.dialog.confirmOperation')}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  onClick={() => {
                    setExcluiItem(true);
                    handleClose();
                  }}
                >
                  {t('global.button.yes')}
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleClose}
                  autoFocus
                >
                  {t('global.button.no')}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div style={{ height: "50vh", width: "100%" }}>
            <DataGrid
              loading={loading}
              rows={rows}
              rowsPerPageOptions={[50, 100, 250, 500]}
              columns={columns}
              experimentalFeatures={{ newEditingApi: true }}
              //   onSelectionModelChange={(ids) => { handleSelectionChange(ids) }}
              key="ContratoItemGrid"
              rowHeight={32}
              onCellClick={(cellValues) => {
                handleClick(cellValues);
              }}
            />
            {mensagem.length > 0 ? TransitionAlerts(severity, mensagem) : null}
          </div>
        </>
      </div>
    </div>
  );
};
